/* KHUN CLUB · página Mi GL: resumen del mes, listas, tarjeta para compartir y exportar/importar.
   Los datos vienen de window.KhunMiGL (khun-mi-gl.js) y el índice de series de la propia página. */
(() => {
  const raiz = document.querySelector('[data-kc-mi-gl-pagina]');
  if (!raiz || !window.KhunMiGL) return;
  const mi = window.KhunMiGL;
  const $ = (sel) => raiz.querySelector(sel);
  const indice = JSON.parse($('[data-kc-mi-indice]').textContent);
  const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const selMes = $('[data-kc-mi-mes]');
  const esc = (t) => String(t ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
  const nombreMes = (clave) => {
    const [a, m] = clave.split('-');
    return `${MESES[Number(m) - 1]} ${a}`;
  };

  // ---- Resumen de un mes ("AAAA-MM") ----
  function resumen(mes) {
    const series = new Set();
    let caps = 0;
    let minutos = 0;
    const ships = new Map();
    const tropos = new Map();
    const terminadas = [];
    let favorita = null;
    for (const [h, s] of Object.entries(mi.todas())) {
      const info = indice[h];
      if (!info) continue;
      const delMes = Object.values(s.caps ?? {}).filter((f) => f && f.startsWith(mes)).length;
      if (delMes) {
        series.add(h);
        caps += delMes;
        minutos += delMes * (info.dur || 0);
        info.s.forEach((sh, i) => ships.set(sh, { n: (ships.get(sh)?.n ?? 0) + delMes, nombre: info.sn[i] }));
        (info.tr || []).forEach((t) => tropos.set(t, (tropos.get(t) ?? 0) + delMes));
      }
      if (s.estado === 'vista' && s.vista?.startsWith(mes)) {
        terminadas.push(info.t);
        if (s.cal && (!favorita || s.cal > favorita.cal)) favorita = { t: info.t, cal: s.cal };
      }
    }
    const mayor = (mapa, valor) => [...mapa.entries()].sort((a, b) => valor(b[1]) - valor(a[1]))[0];
    const ship = mayor(ships, (x) => x.n);
    const tropo = mayor(tropos, (x) => x);
    return {
      series: series.size,
      titulos: [...series].map((h) => indice[h].t),
      caps,
      horas: Math.round(minutos / 6) / 10,
      ship: ship ? ship[1].nombre : '',
      tropo: tropo ? tropo[0] : '',
      terminadas,
      favorita,
    };
  }

  // Meses con actividad (y el actual), del más reciente al más antiguo
  function meses() {
    const d = new Date();
    const actual = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const set = new Set([actual]);
    for (const s of Object.values(mi.todas())) {
      Object.values(s.caps ?? {}).forEach((f) => f && set.add(f.slice(0, 7)));
      if (s.vista) set.add(s.vista.slice(0, 7));
    }
    return [...set].sort().reverse();
  }

  function pintarResumen() {
    const lista = meses();
    const elegido = lista.includes(selMes.value) ? selMes.value : lista[0];
    selMes.innerHTML = lista.map((m) => `<option value="${m}">${nombreMes(m)}</option>`).join('');
    selMes.value = elegido;
    const r = resumen(elegido);
    $('[data-kc-mi-series]').textContent = r.series;
    $('[data-kc-mi-caps]').textContent = r.caps;
    $('[data-kc-mi-horas]').textContent = String(r.horas).replace('.', ',');
    const partes = [];
    if (r.ship) partes.push(`Tu ship del mes: <strong>${esc(r.ship)}</strong>`);
    if (r.tropo) partes.push(`tropo favorito: <strong>${esc(r.tropo)}</strong>`);
    if (r.terminadas.length) partes.push(`terminaste <strong>${esc(r.terminadas.join(', '))}</strong>`);
    if (r.favorita) partes.push(`tu favorita: <strong>${esc(r.favorita.t)}</strong> (${r.favorita.cal}/5)`);
    const frase = partes.join(' · ');
    $('[data-kc-mi-extra]').innerHTML = partes.length
      ? `${frase.charAt(0).toUpperCase()}${frase.slice(1)}.`
      : 'Marca capítulos en las fichas de serie y aquí aparecerá tu mes.';
    $('[data-kc-mi-compartir]').hidden = r.caps === 0 && r.terminadas.length === 0;
  }

  // ---- Listas ----
  function tarjeta(h, s) {
    const info = indice[h];
    const vistos = Object.keys(s.caps ?? {}).length;
    const total = info.ep || 0;
    const siguiente = Math.min(vistos + 1, total || vistos + 1);
    const avance = total ? Math.min(vistos / total, 1) : 0;
    const img = info.img
      ? `<img src="${esc(info.img)}" alt="" width="64" height="80" loading="lazy">`
      : `<span aria-hidden="true">${esc(info.t.slice(0, 2))}</span>`;
    let accion = '';
    if (s.estado === 'viendo' && info.ver) {
      accion = `<a class="kc-btn kc-btn--small kc-btn--amber" href="${esc(info.ver)}" target="_blank" rel="noopener">Seguir: capítulo ${siguiente}<span class="kc-visually-hidden"> en ${esc(info.vpl)} (se abre en otra pestaña)</span></a>`;
    } else if (s.estado === 'quiero') {
      accion = `<a class="kc-btn kc-btn--small kc-btn--white" href="${esc(info.u)}#donde-ver">Dónde verla</a>`;
    }
    const progreso =
      total && s.estado !== 'quiero'
        ? `<div class="kc-progreso__barra" style="--kc-avance:${avance}" aria-hidden="true"><span></span></div><p class="kc-mono kc-meta">${vistos} de ${total} capítulos</p>`
        : total
          ? `<p class="kc-mono kc-meta">${total} capítulos</p>`
          : '';
    const nota = s.estado === 'vista' && s.cal ? `<p class="kc-mi__nota">Tu calificación: ${s.cal}/5</p>` : '';
    return `<li class="kc-mi__serie">
      <a class="kc-mi__poster" href="${esc(info.u)}" tabindex="-1" aria-hidden="true">${img}</a>
      <div class="kc-mi__info">
        <h3 class="kc-mi__titulo"><a href="${esc(info.u)}">${esc(info.t)}</a></h3>
        ${progreso}
        ${nota}
        ${accion}
      </div>
    </li>`;
  }

  function pintarListas() {
    const todas = Object.entries(mi.todas()).filter(([h]) => indice[h]);
    $('[data-kc-mi-vacio]').hidden = todas.length > 0;
    for (const grupo of raiz.querySelectorAll('[data-kc-mi-grupo]')) {
      const estado = grupo.dataset.kcMiGrupo;
      const items = todas.filter(([, s]) => s.estado === estado).sort((a, b) => (b[1].act ?? '').localeCompare(a[1].act ?? ''));
      grupo.hidden = items.length === 0;
      grupo.querySelector('[data-kc-mi-n]').textContent = items.length;
      grupo.querySelector('[data-kc-mi-lista]').innerHTML = items.map(([h, s]) => tarjeta(h, s)).join('');
    }
  }

  function pintar() {
    pintarResumen();
    pintarListas();
  }

  // ---- Tarjeta para compartir (imagen 1080 × 1350 hecha en el navegador) ----
  async function imagenDelMes() {
    const mes = selMes.value;
    const r = resumen(mes);
    try {
      await Promise.all([
        document.fonts.load('900 120px Archivo'),
        document.fonts.load('italic 400 84px "Instrument Serif"'),
        document.fonts.load('500 32px "JetBrains Mono"'),
        document.fonts.load('400 40px "Instrument Sans"'),
      ]);
    } catch {}
    const c = document.createElement('canvas');
    c.width = 1080;
    c.height = 1350;
    const x = c.getContext('2d');
    if ('fontStretch' in x) x.fontStretch = 'expanded';
    const TINTA = '#161513';
    const caja = (px, py, w, h, color, sombra = 14) => {
      x.fillStyle = TINTA;
      x.beginPath();
      x.roundRect(px + sombra, py + sombra, w, h, 28);
      x.fill();
      x.fillStyle = color;
      x.beginPath();
      x.roundRect(px, py, w, h, 28);
      x.fill();
      x.lineWidth = 7;
      x.strokeStyle = TINTA;
      x.stroke();
    };
    x.fillStyle = '#FDF9EE';
    x.fillRect(0, 0, 1080, 1350);
    x.fillStyle = TINTA;
    x.font = '500 30px "JetBrains Mono", monospace';
    x.fillText('MI MES EN EL GL', 80, 120);
    x.font = 'italic 400 84px "Instrument Serif", Georgia, serif';
    x.fillText(nombreMes(mes).replace(/^./, (l) => l.toUpperCase()), 80, 220);

    const cifras = [
      ['SERIES', r.series, '#FF5A36'],
      ['CAPÍTULOS', r.caps, '#F4B234'],
      ['HORAS', String(r.horas).replace('.', ','), '#3DC99F'],
    ];
    cifras.forEach(([etq, valor, color], i) => {
      const px = 80 + i * 315;
      caja(px, 290, 280, 260, color);
      x.fillStyle = TINTA;
      x.font = '900 112px Archivo, "Arial Black", sans-serif';
      x.fillText(String(valor), px + 28, 440);
      x.font = '500 26px "JetBrains Mono", monospace';
      x.fillText(etq, px + 30, 510);
    });

    caja(80, 630, 900, 490, '#FFFFFF');
    x.fillStyle = TINTA;
    let y = 710;
    const linea = (etq, valor) => {
      if (!valor) return;
      x.font = '500 26px "JetBrains Mono", monospace';
      x.fillText(etq, 125, y);
      x.font = '700 46px "Instrument Sans", Arial, sans-serif';
      const texto = valor.length > 34 ? `${valor.slice(0, 33)}…` : valor;
      x.fillText(texto, 125, y + 56);
      y += 112;
    };
    linea('TU FAVORITA', r.favorita ? `${r.favorita.t} · ${r.favorita.cal}/5` : '');
    linea('SHIP DEL MES', r.ship);
    linea('TROPO FAVORITO', r.tropo);
    linea('SERIES', r.titulos.slice(0, 3).join(' · '));

    x.fillStyle = TINTA;
    x.font = '900 64px Archivo, "Arial Black", sans-serif';
    x.fillText('KHUN CLUB.', 80, 1230);
    x.font = '500 28px "JetBrains Mono", monospace';
    x.fillText('gltailandes.com/pages/mi-gl', 80, 1280);
    return new Promise((ok) => c.toBlob(ok, 'image/png'));
  }

  async function compartir() {
    const boton = $('[data-kc-mi-compartir]');
    boton.disabled = true;
    try {
      const blob = await imagenDelMes();
      const archivo = new File([blob], `mi-gl-${selMes.value}.png`, { type: 'image/png' });
      if (navigator.canShare?.({ files: [archivo] })) {
        await navigator.share({ files: [archivo], title: 'Mi mes en el GL', text: 'Mi mes en el GL · KHUN CLUB' });
      } else {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = archivo.name;
        a.click();
        setTimeout(() => URL.revokeObjectURL(a.href), 5000);
      }
    } catch {
      /* compartir cancelado */
    } finally {
      boton.disabled = false;
    }
  }

  // ---- Exportar, importar y borrar ----
  $('[data-kc-mi-exportar]').addEventListener('click', () => {
    const blob = new Blob([mi.exportar()], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'mi-gl-khun-club.json';
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 5000);
  });
  $('[data-kc-mi-importar]').addEventListener('change', async (e) => {
    const archivo = e.target.files?.[0];
    if (!archivo) return;
    try {
      const texto = await archivo.text();
      if (mi.cuenta() && !confirm('Importar reemplaza tu lista actual por la del archivo. ¿Continuar?')) return;
      mi.importar(texto);
      alert('Listo: importamos tu lista.');
    } catch {
      alert('Ese archivo no parece una lista de Mi GL.');
    } finally {
      e.target.value = '';
    }
  });
  $('[data-kc-mi-borrar]').addEventListener('click', () => {
    if (confirm('¿Borrar toda tu lista de Mi GL de este navegador? No se puede deshacer.')) mi.borrarTodo();
  });

  selMes.addEventListener('change', pintarResumen);
  $('[data-kc-mi-compartir]').addEventListener('click', compartir);
  mi.alCambiar(pintar);
  pintar();
})();
